import React from 'react';
import {libraryDriveUrl} from '../libraryDriveLinks';
export function bookReadingRoute(item){
 if(item?.source_type!=='book'||!/^[a-zA-Z0-9:_-]{8,100}$/.test(item.source_id||''))return null;
 return '/kutuphane?'+new URLSearchParams({kaynak:'book:'+item.source_id,oku:'1'});
}
export function bookPreviewUrl(item){const url=libraryDriveUrl(item);return url?url.replace(/\/view$/,'/preview'):null;}
export default function BookSourceReader({item,title,onClose}){
 const src=bookPreviewUrl(item),route=bookReadingRoute(item);
 if(!src||!route)return null;
 return <section className="book-source-reader" aria-label="Kitap kaynak okuyucusu">
  <header><h3>{title}</h3><button onClick={onClose}>Okuyucuyu kapat</button></header>
  <p>Dosyanın mevcut Google Drive izinleri geçerlidir. Sayfa ve yakınlaştırma kontrollerini dosya görüntüleyicisinden kullanabilirsiniz. Görüntüleyici açılmazsa kaynağı yeni sekmede açın.</p>
  <div className="archive-view"><a href={libraryDriveUrl(item)} target="_blank" rel="noopener noreferrer">Kaynağı yeni sekmede aç ↗</a><a href={route}>Bu kaydın okuma bağlantısı</a></div>
  <iframe key={src} src={src} title={title+' · PDF kaynak görünümü'} sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox" referrerPolicy="no-referrer" />
 </section>;
}
